import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-are-you-sure',
  templateUrl: './are-you-sure.component.html',
  styleUrls: ['./are-you-sure.component.scss'],
})
export class AreYouSureComponent {
  @Input() titleTextOverride = 'Are you sure?';
  @Input() yesTextOverride = 'Yes';
  @Input() noTextOverride = 'No';
  @Input() yesEvent: () => void = () => {};
  @Input() noEvent: () => void = () => {};
  @Output() closeDialogEvent = new EventEmitter<boolean>();

  handleYes() {
    this.yesEvent();
    this.closeDialog(true);
  }

  handleNo() {
    this.noEvent();
    this.closeDialog(false);
  }

  closeDialog(refresh: boolean) {
    this.closeDialogEvent.emit(refresh);
  }
}
